import * as React from 'react';

export class Padder extends React.PureComponent {

    render() {
        return <div style={ { display: 'flex', flex: 1 } }></div>;
    }
}
